import { compose, withState, withProps } from 'recompose'
import cuid from 'cuid'

const withStores = () => (
  compose(
    withState('isNew', 'setIsNew', false),
    withState('isEditing', 'setIsEditing', false),
    withState('editingStoreIndex', 'setEditingStoreIndex', undefined),
    withProps(() => ({
      createStoreLocation: () => {
        const newId = cuid()
        return {
          id: newId,
          name: {
            en: '',
            th: '',
          },
          image: {
            source: '',
            link: '',
          },
          isActive: true,
          address: {
            en: '',
            th: '',
          },
          phone: '',
          location: {
            lat: '',
            lng: '',
          },
          tags: '',
          openHours: [],
        }
      },
    })),
  )
)

export default withStores



// WEBPACK FOOTER //
// ./src/pages/StoreLocator/hocs/withStores.js